import React from 'react';
import { privacyvaultContent } from '../rich-content/privacyvault-complete-content';
import { AutomaticPageBuilder } from '../page-sections/automatic-page-builder';

const PrivacyvaultDetailPage = () => {
  return <AutomaticPageBuilder content={privacyvaultContent} />;
};

export default PrivacyvaultDetailPage;
